import JournalButton from './JournalButton.react';
import PermissionStore from '../../../stores/PermissionStore';
import { Permissions } from '../../../constants/PermissionConstants';

class JournalNote extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            subject : '',
            body    : '',
            html    : false
        };
    }

    componentWillReceiveProps(next) {
        var selected = next.selected;

        var html = false;
        var body = '';

        if (selected) {
            if (selected.Note.indexOf('<html>') !== -1) {
                html = true;
            }
        }

        this.setState({
            subject : selected ? selected.NoteSubject : '',
            body    : selected ? selected.Note : '',
            html    : html
        });
    }

    render() {
        var selected = this.props.selected;
        var guest    = this.props.guest;

        return (
            <div className='journal-note'>

                { !this.state.html &&
                    <input
                        type='text'
                        id='note-subject'
                        className='input-text-1'
                        value={this.state.subject}
                        placeholder='Subject...'
                        onChange={(e) => { this.setState({ subject : e.target.value }); }}
                        disabled={!PermissionStore.userCan(Permissions.EditPatientJournalEntries) && this.props.selected != false }
                    />
                }

                { selected && this.state.html &&
                    <div
                        className='journal-note__html'
                        dangerouslySetInnerHTML={{ __html: selected.Note }} />
                }

                { !this.state.html &&
                    <textarea
                        value={this.state.body}
                        id='note-body'
                        className='input-text-1'
                        placeholder='Note'
                        onChange={(e) => { this.setState({ body : e.target.value }); }}
                        disabled={!PermissionStore.userCan(Permissions.EditPatientJournalEntries) && this.props.selected != false} />
                }

                <JournalButton
                    selected={selected}
                    guest={guest}
                    subject={this.state.subject}
                    body={this.state.body}
                    html={this.state.html}
                    onRefresh={() => { this.props.onRefresh(); }} />

            </div>
        );
    }
}

export default JournalNote;



// WEBPACK FOOTER //
// ./ui_src/app/components/popup/journal/JournalNote.react.jsx